import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { onboardingScriptSource, onboardingSettingsSource, blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, } from 'app.constants';
import './sidebar/OnboardingSidebar.scss';
export class OnboardingController {
    static $inject = ['TranslateService', 'AccountService2'];
    constructor(TranslateService, AccountService2) {
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.settingsSource = onboardingSettingsSource;
        MicroFrontendService.addSource(onboardingScriptSource);
        this.user = this.AccountService2.meSync();
        this.language = this.TranslateService.getCurrentLanguage();
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
    }
}
OnboardingController.$inject = ['TranslateService', 'AccountService2'];
